import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';
import { rejectUsedBrokerOptions } from 'bundles/apex/deals/helpers/commissions';

export function InternalBrokersInput({ deal, broker, transactionSide, userOptions, onChange }) {
  const commissions = deal.commissions.filter(commission => !commission.outside);

  const options = rejectUsedBrokerOptions(userOptions, commissions, transactionSide).sort(
    (a, b) => a.label.localeCompare(b.label)
  );
  const enabledBrokerOptions = options.filter(option => !option.disabled);
  const disabledBrokerOptions = options.filter(option => option.disabled);

  let formOptions;

  if (disabledBrokerOptions.length) {
    formOptions = <React.Fragment>
      <optgroup key="enabled" label="Enabled">
        <Options options={enabledBrokerOptions} />
      </optgroup>
      <optgroup key="disabled" label="Disabled">
        <Options options={disabledBrokerOptions} />
      </optgroup>
    </React.Fragment>;
  } else {
    formOptions = <Options options={enabledBrokerOptions} />;
  }

  return (
    <ManagedFormGroup
      includeBlank
      label="Broker"
      required
      type="select"
      value={broker?.id}
      onValueChange={id => onChange(findBroker(options, id))}
    >
      {formOptions}
    </ManagedFormGroup>
  );
}

InternalBrokersInput.propTypes = {
  broker: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      broker: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string,
  userOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  userOptions: state.options.users,
});

export default connect(mapStateToProps)(InternalBrokersInput);

function findBroker(options, id) {
  const option = options.find(option => option.value === parseInt(id));
  if (option) {
    return {
      id: option.value,
      name: option.label,
    };
  }
}
